import getStore from "../store/store";
import type { MailboxInfo } from "owa-client-types";
import { getAccountKeyForMailboxInfo } from "owa-client-types";

export default function isCopilotPrioritizeSettingsInitialized(mailboxInfo: MailboxInfo): boolean {
    const store = getStore().copilotPrioritizeSettingsStoreMap.get(getAccountKeyForMailboxInfo(mailboxInfo));
    
    return store?.isInitialized ?? false;
}
